import React from 'react';
import { Checkbox, Row, Col, Tooltip } from 'antd';
import { connect } from 'dva';

const ScanRunningInstances = props => {
  const { scanRunningInstances } = props;

  return (
    <>
      <h5
        style={{
          color: 'black',
          display: 'flex',
          alignItems: 'center',
          gap: '0.3rem',
        }}
      >
        Choose Configuration
      </h5>
      <div
        style={{
          backgroundColor: '#FAFAFA',
          padding: ' 1rem 2rem',
          marginBottom: '25px',
          borderRadius: '8px',
          fontSize: '14px',
          fontWeight: '400',
          lineHeight: '22px',
          letterSpacing: '0em',
          textAlign: 'left',
          color: '#252525A6',
        }}
      >
        <Row>
          <Col span={24}>
            <Row
              gutter={24}
              style={{
                marginBottom: '10px',
              }}
            >
              <Col>
                <p>
                  This configuration is recommended to first-time users for a much quicker &
                  cost-efficient process. Unselecting this configuration will make Cloudxray scan
                  all your EC2 instances - running instances as well as stopped instances. You can
                  change this later from this Cloud Account's configurations.
                </p>
              </Col>
            </Row>
            <Row
              gutter={24}
              style={{
                marginBottom: '20px',
              }}
            >
              <Col span={14}>
                <Checkbox
                  checked={scanRunningInstances}
                  name="scanRunningInstances"
                  onChange={e => {
                    const { dispatch } = props;
                    dispatch({
                      type: 'cloudAccount/save',
                      payload: { scanRunningInstances: e.target.checked },
                    });
                  }}
                >
                  <p
                    style={{
                      color: '#252525A6',
                    }}
                  >
                    Scan running instances only.
                  </p>
                </Checkbox>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default connect(({ cloudAccount }) => ({
  scanRunningInstances: cloudAccount.scanRunningInstances,
}))(ScanRunningInstances);
